"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@components/custom-metrics/custom-metrics-modal-controller");
var angular_1 = require("angular");
var custom_metrics_modal_html_1 = __importDefault(require("./custom-metrics-modal.html"));
(function (module) {
    module.factory('pr.customMetricsModal', [
        'qstrap.modal',
        function (modal) {
            return {
                show: show
            };
            function show() {
                return modal({
                    templateUrl: custom_metrics_modal_html_1.default,
                    controller: 'pr.customMetricsModalController',
                    show: true
                });
            }
        }
    ]);
})(angular_1.module('qualtrics.pr'));
